import script from "./ChatAdminErrorView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatAdminErrorView.vue?vue&type=script&setup=true&lang=js"

import "./ChatAdminErrorView.vue?vue&type=style&index=0&id=30d80e6f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30d80e6f"]])

export default __exports__